// High-level E2E session: ties X3DH + Double Ratchet into encrypt/decrypt of a
// single message. Framework-agnostic; the wire encoding and SDK hooks live in a
// separate integration layer.

import { initAlice, initBob, ratchetEncrypt, ratchetDecrypt } from './double-ratchet.js';
import { initiatorX3DH, responderX3DH } from './x3dh.js';

const concat = (a, b) => { const o = new Uint8Array(a.length + b.length); o.set(a, 0); o.set(b, a.length); return o; };

// Alice starts a session to a fetched bundle. Returns { session, init } — `init`
// travels (once) alongside the first ciphertext so Bob can set up his side.
export function startSession(myIdentity, theirBundle) {
  const { sk, ad, ratchetPub, init } = initiatorX3DH(myIdentity, theirBundle);
  return { session: { rs: initAlice(sk, ratchetPub), ad }, init };
}

// Bob accepts Alice's first init and builds his session.
export function acceptSession(myIdentity, myPrekeys, init) {
  const { sk, ad, ratchetKeyPair } = responderX3DH(myIdentity, myPrekeys, init);
  return { rs: initBob(sk, ratchetKeyPair), ad };
}

// extraAad (optional): topicId+senderId bytes bound into the AEAD AAD (КР-7),
// so the server cannot move a ciphertext to another topic/sender undetected.
export function encrypt(session, plaintext, extraAad, aead) {
  const ad = extraAad ? concat(session.ad, extraAad) : session.ad;
  return ratchetEncrypt(session.rs, plaintext, ad, aead);
}

export function decrypt(session, header, ct, tag, extraAad, aead) {
  const ad = extraAad ? concat(session.ad, extraAad) : session.ad;
  return ratchetDecrypt(session.rs, header, ct, tag, ad, aead);
}
